import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { GoogleLogin } from '@react-oauth/google';
import { useHistory } from 'react-router-dom';
import { getGGResponse, setReloadIcon } from '../../redux/authSlice';
import { setTreeLoading } from '../../components/familytree/scripts/tree-slice';
import { cleanUpState } from '../../redux/modalSlice';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

const LoginDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  margin: 20px;
`;
const BorderDiv = styled.div`
  border-top: 1px solid black;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding: 20px;
`;

const LoginGG = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const reloadIcon = () => {
    dispatch(setReloadIcon(true));
  };

  const onGetResponse = async (response) => {
    try {
      const userInfo = await dispatch(getGGResponse({ res: response || '', callback: reloadIcon }));
      dispatch(cleanUpState());
      // debug-console.log('userInfo=', userInfo);
      dispatch(setTreeLoading(true));
      if (location.pathname.includes('/login')) {
        history.push('/');
      }
    } catch (err) {
      // handle login error
    }
  };

  const errorMessage = (error) => {
    console.log(error);
  };

  return (
    <LoginDiv>
      <BorderDiv>
        <GoogleLogin onSuccess={onGetResponse} onError={errorMessage} />
      </BorderDiv>
    </LoginDiv>
  );
};

export default LoginGG;
